import { React, useEffect, useState } from "react";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ToolsTab from "../../../components/toolsTab";
import VideoBanner from "../../../components/videoBanner";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import observacion from "../../../assets/images/observacion.svg";
import img_colibri from "../../../assets/images/img_colibri.png";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const Watching360Screen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const cielo = "5Ke8oY85S8M";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <VideoBanner idVideo={cielo}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit">
            <div className="absolute right-0  mt-[15rem] mb-10">
            <img
                src={img_colibri}
                className="lg:w-[50rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>
            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
            <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-lg"
                fontSize="text-lg"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-6"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
          <div className="text-left h-fit col-span-2 text-black lg:mr-10 sm:bottom-0 bg-white w-full z-10 relative">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Aves"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Observación desde punto de vista fijo en 360 grados
                    </h1>
                  }
                  text={
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      Consiste en que el{" "}
                      <b>
                        observador permanezca inmóvil o casi inmóvil en
                        un punto fijo
                      </b>{" "}
                      y registre todas las aves que pueda ver y escuchar
                      desde ese punto, sin importar la distancia a la que se{" "}
           encuentren por un período de <b>30 minutos</b>.
                    </p>
                  }
                ></ToolsInfoSection>
                <img loading="lazy" src={observacion} className=" px-20 w-full mb-40"></img>
              </div>
              <div className="relative col-span-3 2xl:mt-[50rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                  <ToolsTab
                  firstTitle="Fragmentos de bosque"
                  secondTitle="Resultados y beneficios"
                    firstTab={
                      <div>
                        <p className="text-xl">
                          Fragmentos de bosque secundario cerca de paisajes
                          productivos. Deben tenerse en cuenta aspectos como las
                          migraciones y el comportamiento estacional. Se puede
                          aplicar en parques, zonas con árboles, áreas urbanas o
                          zonas en regeneración.
                        </p>
                        <p className="text-xl mt-5">
                          Se puede aplicar en parques, zonas con árboles, áreas
                          urbanas o zonas en regeneración.
                        </p>
                      </div>
                    }
                    secondTab={
                      <div>
                        <p className="text-xl mb-5">
                        Los resultados del monitoreo pueden evidenciar el aumento de riqueza de especies y de la calidad del hábitat en los fragmentos que se monitorean.
                        </p>
                        <p className="text-xl mb-5">
                          Evidencia que las prácticas sostenibles o las medidas
                          de conservación implementadas por las empresas tienen
                          impacto real en el aumento de la biodiversidad y que
                          la empresa protege sitios importantes.
                        </p>
                        <p className="text-xl mb-5">
                          A través del análisis de las especies pueden surgir
                          nuevos atractivos turísticos y especies llamativas.
                        </p>
                      </div>
                    }
                  ></ToolsTab>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          
          <div className="w-full absolute ">
          <VideoBanner idVideo={cielo}></VideoBanner>
            <div className=" absolute right-0 bottom-0 ">
            <img
            
                src={img_colibri}
                className="lg:w-[35rem] md:w-[25rem] sm:w-[15rem] w-[15rem]"
              ></img>
            </div>
          </div>

          <div className="grid grid-cols-1 2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[30rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
            <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-lg"
                fontSize="text-lg"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-6"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              
            <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Aves"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-5 ">
                      Observación desde punto de vista fijo en 360 grados
                    </h1>
                  }
                  text={
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-[15.5rem] mg:pb-[5rem] sm:pb-[5rem] pb-[5rem]">
                      Consiste en que el{" "}
                      <b>
                        observador permanezca inmóvil o casi inmóvil en
                        un punto fijo
                      </b>{" "}
                      y registre todas las aves que pueda ver y escuchar
                      desde ese punto, sin importar la distancia a la que se{" "}
                     encuentren por un periodo de <b>30 minutos</b>.
                    </p>
                  }
                ></ToolsInfoSection>
                <img loading="lazy" src={observacion} className=" px-20 w-full mb-40"></img>
            </div>



            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
              <ToolsTab
              firstTitle="Fragmentos de bosque"
              secondTitle="Resultados y beneficios"
                firstTab={
                  <div>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Se recomienda monitorear la presencia de anfibios y
                      reptiles en los fragmentos de bosque secundario y bosques
                      de ribera asociados a ríos, en paisajes productivos.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      En cuanto a operaciones turísticas, se recomienda
                      identificar la presencia de anfibios o reptiles en los
                      terrenos privados, ya sean bosques maduros o en
                      regeneración.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                    Se debe priorizar los sitios cercanos a cuerpos de agua: márgenes de arroyos, ríos, pozas o sitios con agua estancada, ya sean permanentes o estacionales.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Se recomienda realizar el monitoreo cada 6 meses.
                    </p>
                  </div>
                }
                secondTab={
                  <div>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sme mb-5">
                      Los resultados del monitoreo pueden evidenciar el aumento
                      de riqueza de especies.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Brinda información para proteger sitios importantes para
                      la biodiversidad.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                    A través del análisis de las especies pueden surgir nuevos atractivos turísticos y especies llamativas.
                    </p>
                  </div>
                }
              ></ToolsTab>
            </div>
          </div>


        </div>
      )}
    </div>
  );
};

export default Watching360Screen;
